import { AxiosRequestConfig } from "axios";
import ApiClient from "src/utils/ApiClient";
import {
  EventLogsSubscription,
  EventLogsPaymentPeriod,
  EventLogsSubscriptionsSchema,
} from "./models";

export type QueryParams = {
  filters?: string;
  page?: number;
  size?: number;
  sort?: string[];
};

type RequestConfig = Pick<AxiosRequestConfig, "signal">;
interface PagedContent<T> {
  content: T[];
  totalElements: number;
}

const EventLogsApiClient = new ApiClient({
  baseURL: "/api/event-logs/rest",
  headers: {},
}).client;

export const fetchSubscriptionsSchema = async ({
  signal,
}: RequestConfig): Promise<EventLogsSubscriptionsSchema> => {
  const { data } = await EventLogsApiClient.get(`/v1/subscriptions/schema`, {
    signal,
  });
  return data;
};

export const fetchSubscriptions = async (
  params: QueryParams,
  { signal }: RequestConfig
): Promise<PagedContent<EventLogsSubscription>> => {
  const { data } = await EventLogsApiClient.get(`/v1/subscriptions`, {
    params,
    signal,
  });
  return data;
};

export const fetchSubscription = async (
  id: string,
  { signal }: RequestConfig
): Promise<EventLogsSubscription> => {
  const { data } = await EventLogsApiClient.get(`/v1/subscriptions/${id}`, {
    signal,
  });
  return data;
};

export const fetchSubscriptionPaymentsPeriods = async (
  params: QueryParams,
  { signal }: RequestConfig
): Promise<PagedContent<EventLogsPaymentPeriod>> => {
  const { data } = await EventLogsApiClient.get(`/v1/payments_periods`, {
    params,
    signal,
  });
  return data;
};
